import script from "./OdeSaktu.vue?vue&type=script&setup=true&lang=js"
export * from "./OdeSaktu.vue?vue&type=script&setup=true&lang=js"

import "./OdeSaktu.vue?vue&type=style&index=0&id=52edd655&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52edd655"]])

export default __exports__